import axios from "axios";
import CryptoJS from "crypto-js";

export const apiUrl = "https://payin-sandbox.snapgopay.com/api/user/"; // Production - Base URL
export const traderApiUrl = "https://payout-sandbox.snapgopay.com/api/v1/"; // Production - Payment System URL

const signContent = (url, body, apiKey) => {
    const stringifiedObj = {};

    for (const key in body) {
        if (Object.hasOwnProperty.call(body, key) && !('File' in window && body[key] instanceof File)) {
            stringifiedObj[key] = String(body[key]).trim();
        }
    }

    const plainContent = `/${url.substring(url.lastIndexOf('/') + 1)}${body ? JSON.stringify(stringifiedObj) : "{}"}${localStorage.getItem("salt_key") || sessionStorage.getItem("salt_key")}`;
    // console.log(plainContent)
    return CryptoJS.HmacSHA256(plainContent, apiKey).toString(CryptoJS.enc.Hex);
}

const Environment = {
    postMethod: async (action, object, baseUrl = apiUrl) => {
        const url = baseUrl + action;

        let formData = new FormData();
        // append your data
        for (var key in object)
            formData.append(key, object[key]);

        const accessToken = localStorage.getItem("token") ?
            localStorage.getItem("token")
            : sessionStorage.getItem("token") ?
                sessionStorage.getItem("token")
                : "";

        //signature generation
        const apiKey = (localStorage.getItem('api_key') || sessionStorage.getItem('api_key'));
        let signature = "";
        if (apiKey) {
            signature = signContent(action, object, apiKey);
        }
        let config = { headers: { Authorization: 'Bearer ' + accessToken, 'X-Api-Key': ((localStorage.getItem('api_key') || sessionStorage.getItem('api_key'))) || "", 'X-Api-Signature': signature } };

        return await axios.post(url, formData, config);
    },
    getMethod: async (action, object) => {
        let userId =
            localStorage.getItem("userId") !== "" &&
                localStorage.getItem("userId") !== null &&
                localStorage.getItem("userId") !== undefined
                ? localStorage.getItem("userId")
                : "";
        let accessToken =
            localStorage.getItem("accessToken") !== "" &&
                localStorage.getItem("accessToken") !== null &&
                localStorage.getItem("accessToken") !== undefined
                ? localStorage.getItem("accessToken")
                : "";

        const url = apiUrl + action;

        let formData = new FormData();

        // By Default Id and token

        formData.append("id", userId);
        formData.append("token", accessToken);

        // append your data
        for (var key in object) {
            formData.append(key, object[key]);
        }

        // By Default added device type and login type in future use

        // formData.append("login_by", LOGIN_BY);
        // formData.append("device_type", DEVICE_TYPE);
        // formData.append("device_token", DEVICE_TOKEN);

        return await axios.get(url, formData);
    },

    traderPostMethod: async (action, object, baseUrl = traderApiUrl) => {

        const url = baseUrl + action;

        let formData = new FormData();
        // append your data
        for (var key in object)
            formData.append(key, object[key]);

        const accessToken = localStorage.getItem("token") ?
            localStorage.getItem("token")
            : sessionStorage.getItem("token") ?
                sessionStorage.getItem("token")
                : "";

        const apiKey = localStorage.getItem("api_key") ?
            localStorage.getItem("api_key")
            : sessionStorage.getItem("api_key") ?
                sessionStorage.getItem("api_key")
                : "";

        const token = object?.is_central ? apiKey : accessToken;

        let signature = "";
        if (apiKey) {
            signature = signContent(action, object, apiKey);
        }
        let config = { headers: { Authorization: 'Bearer ' + token, 'X-Api-Key': apiKey, 'X-Api-Signature': signature } };
        return await axios.post(url, formData, config);
    },
    traderGetMethod: async (action, object) => {
        let userId =
            localStorage.getItem("userId") !== "" &&
                localStorage.getItem("userId") !== null &&
                localStorage.getItem("userId") !== undefined
                ? localStorage.getItem("userId")
                : "";
        const accessToken = localStorage.getItem("token") ?
            localStorage.getItem("token")
            : sessionStorage.getItem("token") ?
                sessionStorage.getItem("token")
                : "";

        const centralToken = localStorage.getItem("api_key") ?
            localStorage.getItem("api_key")
            : sessionStorage.getItem("api_key") ?
                sessionStorage.getItem("api_key")
                : "";

        const token = object?.is_central ? centralToken : accessToken;


        const url = traderApiUrl + action;

        let formData = new FormData();

        // By Default Id and token

        formData.append("id", userId);
        formData.append("token", token);

        // append your data
        for (var key in object) {
            formData.append(key, object[key]);
        }

        // By Default added device type and login type in future use

        // formData.append("login_by", LOGIN_BY);
        // formData.append("device_type", DEVICE_TYPE);
        // formData.append("device_token", DEVICE_TOKEN);

        return await axios.get(url, formData);
    },

    chatPostMethod: async (action, object, baseUrl = traderApiUrl) => {
        const url = baseUrl + action;

        let formData = new FormData();

        for (var key in object)
            formData.append(key, object[key]);

        const apiKey = (localStorage.getItem('api_key') || sessionStorage.getItem('api_key'));
        let config = { headers: { Authorization: 'Bearer ' + apiKey }};

        return await axios.post(url, formData, config);
    },
};

export default Environment;
